import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\UpdateItemController::__invoke
* @see app/Http/Controllers/Item/UpdateItemController.php
* @route '/api/item/{item}'
*/
const UpdateItemController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemController.url(args, options),
    method: 'put',
})

UpdateItemController.definition = {
    methods: ["put"],
    url: '/api/item/{item}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Item\UpdateItemController::__invoke
* @see app/Http/Controllers/Item/UpdateItemController.php
* @route '/api/item/{item}'
*/
UpdateItemController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return UpdateItemController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\UpdateItemController::__invoke
* @see app/Http/Controllers/Item/UpdateItemController.php
* @route '/api/item/{item}'
*/
UpdateItemController.put = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemController.url(args, options),
    method: 'put',
})

export default UpdateItemController